import React from 'react';
import PropTypes from 'prop-types';
import { ContentZonesService } from '@sm360/widget-commons-core-services';

import { COLANDER_GROUPS } from 'inventory-listing/constants/colanders.js';

const ListingSEOText = ({ colanderGroupSlug }) => {
    let content;
    switch (colanderGroupSlug) {
        case COLANDER_GROUPS.NEW:
            content = ContentZonesService.getContentZone('widget.listing.used', 'widget.listing.used.seo.text.new');
            break;
        default:
            content = ContentZonesService.getContentZone('widget.listing.used', 'widget.listing.used.seo.text');
    }
    if (!content) {
        return null;
    }
    return <div className="listing-used-seo wysiwyg" dangerouslySetInnerHTML={{ __html: content.getValue() }} />;
};

ListingSEOText.defaultProps = {
    colanderGroupSlug: COLANDER_GROUPS.DEFAULT,
};

ListingSEOText.propTypes = {
    colanderGroupSlug: PropTypes.string,
};
ListingSEOText.displayName = 'ListingSEOText';

export default ListingSEOText;
